var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFourth = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 42,
  height: 42,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#0098EA",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M29.75 35V14m0 21-6.125-6.125M29.75 35l6.125-6.125m-23.625.875V7m0 0-6.125 6.125M12.25 7l6.125 6.125"
})));
export default SvgFourth;